import React from 'react';
import { useSlotCount } from '../../state';
import { block } from '../../utils';
import EditSceneOverlaySlot from './EditSceneOverlaySlot';
import EditSceneOverlaySlotDragPreview from './EditSceneOverlaySlotDragPreview';

const EditSceneSlotsOverlay: React.FC = () => {
  const { slotCount } = useSlotCount();

  return (
    <div className={block('slots-overlay')}>
      {Array.from({ length: slotCount }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <EditSceneOverlaySlot key={index} slotIndex={index} />
      ))}
      <EditSceneOverlaySlotDragPreview />
    </div>
  );
};

export default EditSceneSlotsOverlay;
